import * as users from "../api/users";

export default {
  state: {
    users: [],
    user: {}
  },
  mutations: {
    getUsers(state, users) {
      state.users = users;
    },
    getUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    async getUsers({ commit }) {
      const data = await users.getUsers();
      commit("getUsers", data);
    },
    async getUser({ commit }, id) {
      const data = await users.getUser(id);
      commit("getUser", data);
    },
    async createUser({ dispatch }, user) {
      try {
        const response = await users.createUser(user);
        dispatch("getUsers");
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", { message: "emailExist" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updateUser({ dispatch }, { id, user }) {
      try {
        const response = await users.updateUser(id, user);
        dispatch("getUsers");
        dispatch("getUser", id);

        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", { message: "emailExist" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updatePassword({ dispatch }, { id, user }) {
      try {
        const response = await users.updatePassword(id, user);
        dispatch("getUsers");
        dispatch("getUser", id);
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async deleteUser({ dispatch }, { id }) {
      try {
        const response = await users.deleteUser(id);
        dispatch("getUsers");
        return response;
      } catch (error) {
        return { success: false };
      }
    }
  }
};
